var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { attrs: { row: "", wrap: "" } },
        [
          _c(
            "v-flex",
            {
              class: { "ml-5": _vm.$vuetify.breakpoint.mdAndUp },
              staticStyle: { display: "flex" },
              attrs: { xs12: "", "pt-2": "" }
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { bottom: "" },
                  scopedSlots: _vm._u([
                    {
                      key: "activator",
                      fn: function(ref) {
                        var on = ref.on
                        return [
                          _c(
                            "v-btn",
                            _vm._g(
                              {
                                staticClass: "ml-0 text-none",
                                attrs: {
                                  large: "",
                                  color: "primary",
                                  outline: "",
                                  block: _vm.$vuetify.breakpoint.smAndDown
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.open()
                                  }
                                }
                              },
                              on
                            ),
                            [
                              _c("wz-avatar", {
                                attrs: {
                                  username:
                                    _vm.bot[0].USR_FIRST_NAME +
                                    " " +
                                    _vm.bot[0].USR_LAST_NAME,
                                  src:
                                    _vm.domaine +
                                    "/public/media/user/small/" +
                                    _vm.bot[0].USR_ID +
                                    "_avatar.jpg",
                                  size: "35px"
                                }
                              }),
                              _vm._v(
                                "\n             " +
                                  _vm._s(
                                    _vm.bot[0].USR_FIRST_NAME +
                                      " " +
                                      _vm.bot[0].USR_LAST_NAME
                                  ) +
                                  "\n          "
                              )
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                },
                [
                  _vm._v(" "),
                  _c("span", [_vm._v(_vm._s(_vm.$t("selectchatbot")))])
                ]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", persistent: "", "max-width": "350px" },
          model: {
            value: _vm.dialog,
            callback: function($$v) {
              _vm.dialog = $$v
            },
            expression: "dialog"
          }
        },
        [
          _c(
            "v-card",
            [
              _c("v-card-title", { staticClass: "primary white--text" }, [
                _c(
                  "div",
                  { staticClass: "title" },
                  [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function($event) {
                            return _vm.cancel()
                          }
                        }
                      },
                      [
                        _c("v-icon", { staticClass: "white--text" }, [
                          _vm._v("close")
                        ])
                      ],
                      1
                    ),
                    _vm._v(
                      "\n          " +
                        _vm._s(_vm.$t("selectchatbot")) +
                        "\n        "
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticStyle: { height: "400px" } },
                [
                  _c(
                    "v-radio-group",
                    {
                      model: {
                        value: _vm.selectedBot[0],
                        callback: function($$v) {
                          _vm.$set(_vm.selectedBot, 0, $$v)
                        },
                        expression: "selectedBot[0]"
                      }
                    },
                    _vm._l(_vm.listeBots, function(lebot, i) {
                      return _c("v-radio", {
                        key: i,
                        attrs: { value: lebot },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "label",
                              fn: function() {
                                return [
                                  _c(
                                    "div",
                                    [
                                      _c("wz-avatar", {
                                        attrs: {
                                          username:
                                            lebot.USR_FIRST_NAME +
                                            " " +
                                            lebot.USR_LAST_NAME,
                                          src:
                                            _vm.domaine +
                                            "/public/media/user/small/" +
                                            lebot.USR_ID +
                                            "_avatar.jpg",
                                          size: "35px"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("span", { staticClass: "ml-2" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              lebot.USR_FIRST_NAME +
                                                " " +
                                                lebot.USR_LAST_NAME
                                            ) +
                                            "\n              "
                                        )
                                      ]),
                                      _vm._v(" "),
                                      lebot.USR_ID == _vm.$store.state._User.id
                                        ? _c("span", [
                                            _vm._v(
                                              "\n                (" +
                                                _vm._s(_vm.$t("me")) +
                                                ")\n              "
                                            )
                                          ])
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                ]
                              },
                              proxy: true
                            }
                          ],
                          null,
                          true
                        )
                      })
                    }),
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("v-divider"),
              _vm._v(" "),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: {
                        click: function($event) {
                          return _vm.cancel()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("cancel")))]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        disabled:
                          _vm.selectedBotId === _vm.selectedBot[0].USR_ID,
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submit()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("submit")))]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-55192548", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-55192548","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectBots.vue
// module id = null
// module chunks = 